<template>
    <div class="song-panel">
    <transition-group name="fadeUp">
        <div v-for="(track, index) in tracks" v-bind:key="index" class="list-item">

            <div class="song-bar">
                <div class="radio-icon">

                    <svg-icon icon="on_air"
                                  v-if="index === 0 && player.playing && !player.id && player.channel === track.channel_id"/>

                </div>
                <div class="info">
                    <viewer :images="[track.cover]"
                            :options="{navbar:false, title:false, toolbar:false, movable:false, zoomable:false}" >
                        <img class="album" :src="track.cover" alt="album">
                    </viewer>
                    <div class="song-info">
                        <p class="album-name text">{{track.artist}}</p>
                        <p class="song-name text">{{track.title}}</p>
                        <p class="time text">{{track.duration}}</p>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>
    </div>
</template>

<script>
  import SvgIcon from '../layout/SvgIcon'

  export default {
    components: {
      SvgIcon
    },

    props: {
      tracks: null,
      player: {
        playing: false,
        id: null,
        channel: 1
      },
    },
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/radio/SongPanel.vue